const DEFAULT_COLOR_SCHEME = "light";

/**
 * Lazy Highcharts options.palette value - allows this to be dynamic in future
 */
export const getHighchartsPaletteOption = (): Highcharts.PaletteOptions => ({
  colorScheme: DEFAULT_COLOR_SCHEME,
});
